import { itiTokenService } from './../../iti-core-vue/services/iti-token-service';
import { UserManager, WebStorageStateStore, User } from 'oidc-client';
import { itiHttpService, ItiString } from '@/iti-core-vue';
export default class AuthService {
    private userManager: UserManager;
    private user: User | null = null;

    public get username(): string | null {
        return this.user ? this.user.profile.name as string : null;
    }

    constructor() {


        const STS_DOMAIN: string = process.env.VUE_APP_STS_DOMAIN as string; // 'https://localhost:44356';
        const symbinetFront = process.env.VUE_APP_SYMBINET_FRONT as string;

        const settings: any = {
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            authority: STS_DOMAIN,
            client_id: process.env.VUE_APP_SYMBINET_CLIENT_ID as string,
            redirect_uri: symbinetFront + '/callback.html',// 'https://localhost:44357/callback.html',
            automaticSilentRenew: false, //Lo ponemos a false porque bajo capturamos el evento cuando el Access Token caduca y por tanto, no necesitamos silent_redirect_uri
            //silent_redirect_uri: symbinetFront + '/silent-renew',//'https://localhost:44357/silent-renew.html',
            response_type: 'code',
            scope: 'openid profile symbinet',
            post_logout_redirect_uri: symbinetFront,// 'https://localhost:44357',
            filterProtocolClaims: true,
        };

        this.userManager = new UserManager(settings);
        this.afterSigning();
        this.userManager.events.addAccessTokenExpiring(() => {
            this.signinSilentCallback();
        });

    }
    public signinSilentCallback(){
        return this.userManager.signinSilentCallback().then(() => {
            this.afterSigning();
        });
    }

    private afterSigning(){
        this.userManager.getUser()
            .then(user => {
                this.user = user;
                itiTokenService.setToken(user?.access_token as string);
                itiHttpService.updateHeader();
                console.log(user?.access_token);
            });
    }

    public getUser(): Promise<User | null> {
        return this.userManager.getUser();
    }

    public login(): Promise<void> {
        return this.userManager.signinRedirect();
    }

    public logout(): Promise<void> {
        this.clearToken();
        return this.userManager.signoutRedirect();
    }

    public logoutWithoutRedirect(): Promise<void> {
        this.clearToken();
        return this.userManager.signoutCallback();
    }

    public forbidden(): Promise<void> {
        this.clearToken();
        return this.login();
    }

    public clearToken() {
        itiTokenService.clearToken();
        itiHttpService.updateHeader();
    }

    public getAccessToken(): Promise<string> {
        return this.userManager.getUser().then((data: any) => {
            return data.access_token;
        });
    }

    public async completeAuthentication() {
        this.user = await this.userManager.signinRedirectCallback();
    }
}


export const authService = new AuthService();